// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetLedgersApiParameter } from "@store/Framework/Services/LedgerService";

export const getLedgersDataView = (state: ApplicationState, parameter: GetLedgersApiParameter) => {
    return getDataView(state.store.data.ledgers, parameter);
};

export const getLedgerDocumentTypes = (state: ApplicationState) => {
    return state.store.data.ledgers.ledgerDocumentTypes;
};

export const getLedgerStatuses = (state: ApplicationState) => {
    return state.store.data.ledgers.ledgerStatuses;
};

export const getfailedToLoadLedgers = (state: ApplicationState) => {
    return state.store.data.ledgers.failedToLoadLedgers;
};
